module.exports = __webpack_public_path__ + "img/album-backgrounds.39c62cf.jpg";